
// Postal code delivery check
const FREE_DELIVERY_OVER_100 = [
    '2000', '2001', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2015', '2016',
    '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
    '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040',
    '2041', '2042', '2043', '2044', '2045', '2046', '2047', '2048', '2049', '2050', '2052', '2055',
    '2057', '2059', '2060', '2061', '2062', '2063', '2064', '2065', '2066', '2067', '2068', '2069',
    '2070', '2071', '2072', '2073', '2074', '2075', '2076', '2077', '2085', '2086', '2087', '2088',
    '2089', '2090', '2092', '2093', '2094', '2095', '2096', '2097', '2099', '2100', '2101', '2102',
    '2103', '2104', '2109', '2110', '2111', '2112', '2113', '2114', '2115', '2116', '2117', '2118',
    '2119', '2120', '2121', '2122', '2125', '2126', '2127', '2128', '2129', '2130', '2131', '2132',
    '2133', '2134', '2135', '2136', '2137', '2138', '2139', '2140', '2141', '2142', '2143', '2144',
    '2145', '2146', '2147', '2148', '2150', '2151', '2152', '2153', '2154', '2155', '2156', '2158',
    '2160', '2161', '2162', '2163', '2164', '2165', '2166', '2167', '2168', '2170', '2171', '2172',
    '2173', '2174', '2175', '2176', '2177', '2178', '2179', '2190', '2191', '2192', '2193', '2194',
    '2195', '2196', '2197', '2198', '2199', '2200', '2203', '2204', '2205', '2206', '2207', '2208',
    '2209', '2210', '2211', '2212', '2213', '2214', '2216', '2217', '2218', '2219', '2220', '2221',
    '222', '2223', '2761', '2762', '2763', '2766', '2767', '2768', '2769', '2770'
];

const FREE_DELIVERY_OVER_150 = [
    '2224', '2225', '2226', '2227', '2228', '2557', '2558', '2559', '2565', '2566', '2567', '2084',
    '2101', '2106', '2123', '2124', '2156', '2158', '2229', '2230', '2232', '2233', '2234', '2560',
    '2564', '2570', '2747', '2759', '2760', '2765'
];

function checkDelivery() {
    const postalCodeInput = document.getElementById('postal-code');
    const resultDiv = document.getElementById('delivery-result');
    const postalCode = postalCodeInput.value.trim();

    // Clear previous result
    resultDiv.className = 'delivery-result';
    resultDiv.textContent = '';

    if (!postalCode) {
        return;
    }

    // Normalize postal code (pad with zeros if needed, but keep original for comparison)
    const normalizedCode = postalCode.padStart(4, '0');

    // Check if postal code is in the lists
    let isOver100 = FREE_DELIVERY_OVER_100.includes(postalCode) || FREE_DELIVERY_OVER_100.includes(normalizedCode);
    let isOver150 = FREE_DELIVERY_OVER_150.includes(postalCode) || FREE_DELIVERY_OVER_150.includes(normalizedCode);

    // Handle special case: 2101, 2106, 2123, 2124, 2156, 2158 appear in both lists
    // Priority: if in $150 list, show $150; otherwise show $100
    if (isOver150) {
        resultDiv.className = 'delivery-result success';
        resultDiv.textContent = '✓ 可提供当日送达服务！订单满$150免运费';
    } else if (isOver100) {
        resultDiv.className = 'delivery-result success';
        resultDiv.textContent = '✓ 可当日送达！订单满$100免运费';
    } else {
        resultDiv.className = 'delivery-result error';
        resultDiv.textContent = '✗ 此邮政编码区域不提供当日送达服务';
    }
}


function weboostClickMore() {
    const moreTextSection = document.getElementById("weboost-moretext-section");
    const button = document.getElementById("weboost-moreless-button-id");

    if (moreTextSection.classList.contains("weboost-toggle-display")) {
        moreTextSection.classList.remove("weboost-toggle-display");
        button.textContent = "隐藏";
    } else {
        moreTextSection.classList.add("weboost-toggle-display");
        button.textContent = "阅读更多";
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const toggleButtons = document.querySelectorAll('.weboost_collection_seo_toggle');
    
    toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
            const desc = this.previousElementSibling;
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            
            if (isExpanded) {
                desc.classList.remove('expanded');
                this.setAttribute('aria-expanded', 'false');
            } else {
                desc.classList.add('expanded');
                this.setAttribute('aria-expanded', 'true');
            }
        });
    });

     const questions = document.querySelectorAll(".faq-question");

    questions.forEach((question) => {
      question.addEventListener("click", () => {
        question.classList.toggle("active");
        const answer = question.nextElementSibling;
        answer.classList.toggle("show");
      });
    });

  
});














